/* ==========================================================================
   WAENN — Navegacion sin recarga para: cuenta de cliente (legacy, si aplica)
   y la pagina independiente THE W (programa de fidelizacion). Ambas
   comparten los mismos data-attributes para los sub-paneles deslizantes.
   ========================================================================== */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    init();
  }

  var initialized = false;

  function init() {
    if (initialized) return;
    var root = document.querySelector('.waenn-account, [data-waenn-loyalty-page]');
    if (!root) return;
    initialized = true;

    initPanelNav(root);
    initOrderTabs(root);
    initLoyaltySubpanels(root);
    initWishlistBadge(root);
    initLanguagePopover(root);
  }

  /* ------------------------------ Paneles principales (solo cuenta legacy) ------------------------------ */

  function initPanelNav(root) {
    var navButtons = root.querySelectorAll('[data-waenn-nav]');
    var openLoyaltyTriggers = root.querySelectorAll('[data-waenn-open-loyalty]');
    var backButtons = root.querySelectorAll('[data-waenn-back-to-orders]');
    var panels = root.querySelectorAll('[data-waenn-panel]');
    if (!panels.length) return;

    function showPanel(name) {
      panels.forEach(function (panel) {
        var isMatch = panel.getAttribute('data-waenn-panel') === name;
        panel.hidden = !isMatch;
      });
      navButtons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-waenn-nav') === name);
      });
      if (name === 'loyalty') {
        var evt = new CustomEvent('waenn:account:loyalty-opened');
        root.dispatchEvent(evt);
      }
    }

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = btn.getAttribute('data-waenn-nav');
        if (!target) return;
        e.preventDefault();
        showPanel(target);
      });
    });

    openLoyaltyTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        showPanel('loyalty');
      });
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        showPanel('orders');
      });
    });
  }

  /* ------------------------------ Tabs de historial de pedidos (solo cuenta legacy) ------------------------------ */

  function initOrderTabs(root) {
    var tabs = root.querySelectorAll('[data-waenn-tab]');
    var tabPanels = root.querySelectorAll('[data-waenn-tab-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        var target = tab.getAttribute('data-waenn-tab');

        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
        });
        tabPanels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-waenn-tab-panel') !== target;
        });
      });
    });
  }

  /* ------------------------------ Sub-paneles deslizantes de THE W ------------------------------ */

  function initLoyaltySubpanels(root) {
    var track = root.querySelector('[data-waenn-loyalty-track]');
    if (!track) return;

    var openTriggers = root.querySelectorAll('[data-waenn-open-sub]');
    var backTriggers = root.querySelectorAll('[data-waenn-sub-back]');
    var subpanels = root.querySelectorAll('[data-waenn-subpanel]');

    function openSub(name) {
      subpanels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-waenn-subpanel') !== name;
      });
      track.classList.add('is-sub-open');
    }

    function closeSub() {
      track.classList.remove('is-sub-open');
    }

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var target = trigger.getAttribute('data-waenn-open-sub');
        if (!target) return;
        openSub(target);
      });
    });

    backTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        closeSub();
      });
    });
  }

  /* ------------------------------ Wishlist (reutiliza WaennWishlist existente) ------------------------------ */

  function initWishlistBadge(root) {
    var countEls = root.querySelectorAll('[data-waenn-wishlist-count]');
    var openTriggers = root.querySelectorAll('[data-waenn-open-wishlist]');
    if (!countEls.length && !openTriggers.length) return;

    function updateCount() {
      if (!window.WaennWishlist || typeof window.WaennWishlist.getAll !== 'function') return;
      var count = 0;
      try {
        count = window.WaennWishlist.getAll().length || 0;
      } catch (err) {
        count = 0;
      }
      countEls.forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    updateCount();
    document.addEventListener('waenn:wishlist:change', updateCount);

    openTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var drawer = document.querySelector('saved-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      });
    });
  }

  /* ------------------------------ Selector de idioma ------------------------------ */

  function initLanguagePopover(root) {
    var toggle = root.querySelector('[data-waenn-toggle-language]');
    var popover = root.querySelector('[data-waenn-language-popover]');
    if (!toggle || !popover) return;

    popover.hidden = true;

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      popover.hidden = !popover.hidden;
    });

    document.addEventListener('click', function (e) {
      if (popover.hidden) return;
      if (popover.contains(e.target) || toggle.contains(e.target)) return;
      popover.hidden = true;
    });
  }
})();
